import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import * as formatter from '../helpers/CurrencyFormatter';
import * as dateFormatter from '../helpers/DateFormatter';

function BarChart({ data }) {
    const [chartData, setChartData] = useState({});

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
            display: false,
        },
        tooltips: {
            mode: 'label',
            callbacks: {
                label: function (tooltipItem) {
                    return formatter.formatAmount(tooltipItem.value);
                },
                title: function (tooltipTitle) {
                    return dateFormatter.formatDateShort(tooltipTitle[0].xLabel);
                },
            },
        },
        scales: {
            xAxes: [
                {
                    type: 'time',
                    bounds: 'data',
                    unitStepSize: 1,
                    time: {
                        displayFormats: {
                            week: 'MMM D',
                        },
                        unit: 'week',
                    },
                    ticks: {
                        display: true,
                        source: 'auto',
                    },
                    position: 'bottom',
                    gridLines: {
                        display: true,
                        offsetGridLines: true,
                        drawBorder: true,
                        drawTicks: true,
                    },
                },
            ],
            yAxes: [
                {
                    type: 'linear',
                    ticks: {
                        beginAtZero: true,
                        callback: function (value) {
                            return formatter.formatAmount(value);
                        },
                    },
                    position: 'left',
                },
            ],
        },
    };

    const chart = () => {
        setChartData({
            datasets: [
                {
                    fill: false,
                    backgroundColor: 'rgba(75,192,192,0.4)',
                    pointBorderColor: 'rgba(75,192,192,1)',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 1,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: 'rgba(75,192,192,1)',
                    pointHoverBorderColor: 'rgba(220,220,220,1)',
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: data,
                },
            ],
        });
    };

    useEffect(() => {
        chart(data);
    }, [data]);

    return <Bar data={chartData} options={options} />;
}

export default BarChart;
